import React, { forwardRef, useEffect, useState } from "react";
import Barcode from "react-barcode";
import styled from "styled-components";
import Common from "../based/Common";
import { PAYMENT_METHOD } from "../based/Constants";

export const FunctionalComponentToPrint = forwardRef((props, ref) => {
    const [printInfo, setPrintInfo] = useState({ barcode: "179" });
    const [content, setContent] = useState(props.content);
    useEffect(() => {
        setContent(props.content);
        if (props.content.order) setPrintInfo({ ...printInfo, barcode: String(props.content.order.id) });
    }, [props.content]);

    const countTotalItem = (products) => {
        let count = 0;
        if (products && products.length > 0) {
            products.map((item) => {
                count += item.quantity;
            });
        }
        return count;
    };

    return (
        <div ref={ref}>
            <PrinterWrapper className="printer-wrapper">
                <div className="header-barcode">
                    {content.order && content.order.platform === 1 ? (
                        <div className="d-flex mt-2 align-items-start ">
                            <div className="d-flex">
                                <img style={{ width: 333 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                            </div>
                            <div className="barcode">
                                <div className="col-md-12 text-center">
                                    <Barcode value={content.order ? String(content.order.id) : "000000000"} height={80} fontSize={30} width={4} format="CODE128" />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {props.shippingCompanyId && props.shippingCompanyId == 2 ? (
                        <div className="d-flex mt-2 align-items-start ">
                            <div className="d-flex">
                                <img style={{ width: 333 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                            </div>
                            <div className="barcode">
                                <div className="col-md-12 text-center">
                                    <Barcode value={content.order ? String(content.order.id) : "000000000"} height={80} fontSize={30} width={4} format="CODE128" />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {content.order && content.order.platform !== 1 ? (
                    <div className="d-flex mt-2 justify-content-around align-items-start">
                        <div className="w-50 d-flex ">
                            <img style={{ width: 170 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                        </div>
                        <div className="barcode w-50">
                            <div className="col-md-12 text-center">
                                <Barcode value={printInfo.barcode ? printInfo.barcode : "000000000"} height={80} fontSize={30} format="CODE128" />
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <hr />
                <div className="card-info d-flex  justify-content-start">
                    <div className="card-left w-50 d-flex flex-column justify-content-start">
                        <b className="text-dark">Từ</b>
                        <b className="text-dark">Ranus.vn</b>
                        <p>75 Đường số 2,KDC Cityland Park Hills, P10, Gò Vấp, HCM</p>
                        <p>Hotline: 089 8000 004</p>
                    </div>
                    <div className="card-left w-50 d-flex flex-column justify-content-start">
                        <b className="text-dark">Đến</b>
                        <p> {content.shippingAddress && content.shippingAddress.userName ? content.shippingAddress.userName : ""}</p>
                        <p className="">{content.shippingAddress && content.shippingAddress.fullAddress ? content.shippingAddress.fullAddress : ""} </p>
                        <p className="">Số điện thoại:{content.shippingAddress && content.shippingAddress.phoneNumber ? content.shippingAddress.phoneNumber : ""} </p>
                    </div>
                </div>
                <hr />
                <div className="footer-printer d-flex pb-4">
                    <div className="card-left w-50 d-flex flex-column w-50 justify-content-start">
                        <b className="mb-0 text-dark">Tiền thu người nhận: </b>
                        <h4 className="text-dark">{content.order && content.order.finallyPrice && content.order.paymentMethod == PAYMENT_METHOD.COD ? Common.formatCurrency(content.order.finallyPrice) : 0} </h4>
                        <small>Kiểm tra hàng trước khi nhận</small>
                    </div>
                    <div className="card-left w-50 d-flex flex-column w-50 justify-content-start ">
                        <h3 className="text-dark">Chữ ký người nhận:</h3>
                        <small className="font-italic mb-5">Xác nhận hàng còn nguyên niêm phong, không có dấu hiệu bị mở.</small>
                    </div>
                </div>
                <hr />
                <div className="product-info d-flex flex-column w-100  justify-content-start align-items-start">
                    {content.products && content.products.length > 0 ? (
                        <React.Fragment>
                            <div className="w-100 d-flex justify-content-around">
                                <b className="text-dark">Nội dung đơn hàng</b> <b className="text-dark">Tổng số lượng: {countTotalItem(content.products)}</b>
                            </div>

                            {content.products.map((item, idx) => (
                                <p key={idx}>
                                    {idx + 1}. {Common.ProductAttributeDisplay(item.name, item.attributeValueLightModels, item.colorDisplayName)} - SL:{item.quantity}
                                </p>
                            ))}
                        </React.Fragment>
                    ) : (
                        ""
                    )}
                </div>
            </PrinterWrapper>
        </div>
    );
});

export const FunctionalComponentDetail = forwardRef((props, ref) => {
    const [printInfo, setPrintInfo] = useState({ barcode: "0" });
    const [content, setContent] = useState(props.content);
    useEffect(() => {
        setContent(props.content);
        if (props.content.order) setPrintInfo({ ...printInfo, barcode: String(props.content.order.id) });
    }, [props.content]);

    const countTotalItem = (products) => {
        let count = 0;
        if (products && products.length > 0) {
            products.map((item) => {
                count += item.quantity;
            });
        }
        return count;
    };

    return (
        <div ref={ref}>
            <PrinterWrapper className="printer-wrapper">
                <div className="header-barcode">
                    {content.order && content.order.platform === 1 ? (
                        <div className="d-flex mt-2 align-items-center">
                            <div className="d-flex ">
                                <img style={{ width: 333 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                            </div>
                            <div className="barcode abc">
                                <div className="col-md-12 text-center">
                                    <Barcode value={content.order ? String(content.order.shippingOrderNumber) : "000000000"} height={150} fontSize={30} width={4} format="CODE128" />
                                </div>
                                {content.order.sortingCode && (
                                    <div className="col-md-12 text-center">
                                        <Barcode value={String(content.order.sortingCode)} height={150} fontSize={30} format="CODE128" width={4} />
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {props.shippingCompanyId && props.shippingCompanyId == 2 ? (
                        <div className="d-flex mt-2 align-items-start ">
                            <div className="d-flex ">
                                <img style={{ width: 333 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                            </div>
                            <div className="barcode xyz">
                                <div className="col-md-12 text-center">
                                    <Barcode value={content.order ? String(content.order.shippingOrderNumber) : "000000000"} height={80} fontSize={30} width={3} format="CODE128" />
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {content.order && content.order.platform !== 1 ? (
                    <div className="d-flex mt-2 justify-content-around align-items-start">
                        <div className="w-50 d-flex ">
                            <img style={{ width: 170 }} src="./images/Logo-01.png" alt="Ranus.vn" />
                        </div>
                        <div className="barcode w-50">
                            <div className="col-md-12 text-center">
                                <Barcode value={printInfo.barcode ? printInfo.barcode : "000000000"} height={180} fontSize={30} format="CODE128" />
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <hr />
                <div className="card-info d-flex  justify-content-start">
                    <div className="card-left w-50 d-flex flex-column justify-content-start">
                        <b className="text-dark">Từ</b>
                        <b className="text-dark">Ranus.vn</b>
                        <p>75 Đường số 2,KDC Cityland Park Hills, P10, Gò Vấp, HCM</p>
                        <p>Hotline: 089 8000 004</p>
                    </div>
                    <div className="card-left w-50 d-flex flex-column justify-content-start">
                        <b className="text-dark">Đến</b>
                        <p> {content.shippingAddress && content.shippingAddress.userName ? content.shippingAddress.userName : ""}</p>
                        <p className="">{content.shippingAddress && content.shippingAddress.fullAddress ? content.shippingAddress.fullAddress : ""} </p>
                        <p className="">Số điện thoại: {content.shippingAddress && content.shippingAddress.phoneNumber ? content.shippingAddress.phoneNumber : ""} </p>
                    </div>
                </div>
                <hr />
                <div className="footer-printer d-flex pb-4">
                    <div className="card-left w-50 d-flex flex-column w-50 justify-content-start">
                        <b className="mb-0 text-dark">Tiền thu người nhận: </b>
                        <h4 className="text-dark">{content.order && content.order.finallyPrice && content.order.paymentMethod == PAYMENT_METHOD.COD ? Common.formatCurrency(content.order.finallyPrice) : 0} </h4>
                        <small>Kiểm tra hàng trước khi nhận</small>
                    </div>
                    <div className="card-left w-50 d-flex flex-column w-50 justify-content-start"></div>
                </div>
                <hr />
                <div className="product-info d-flex flex-column w-100  justify-content-start align-items-start">
                    {content.products && content.products.length > 0 ? (
                        <React.Fragment>
                            <div className="w-100 d-flex justify-content-around">
                                <b className="text-dark">Nội dung đơn hàng</b> <b className="text-dark">Tổng số lượng: {countTotalItem(content.products)}</b>
                            </div>

                            {content.products.map((item, idx) => (
                                <p key={idx}>
                                    {idx + 1}. {Common.ProductAttributeDisplay(item.name, item.attributeValueLightModels, item.colorDisplayName)} - SL:{item.quantity}
                                </p>
                            ))}
                        </React.Fragment>
                    ) : (
                        ""
                    )}
                </div>
            </PrinterWrapper>
        </div>
    );
});

const PrinterWrapper = styled.div`
    background: #fff;
    padding: 30px;
    margin: 10px 10px 10px 10px !important;
    font-size: 32px;
    font-family: "Lexend";
    .card-left {
        padding: 5px 10px 10px 5px;
    }
    h2 {
        margin: 0 0 10px 0;
    }
    h4 {
        font-size: 58px;
        font-weight: 600;
    }
    hr {
        color: #000;
        background: #000;
    }
    @page {
        size: A4 portrait;
    }
    .logo-header {
        text-transform: uppercase;
    }
    .order-info p {
        max-width: 70%;
    }
    .card-info p {
        margin-bottom: 0.3rem;
    }
    .barcode {
        margin-left: auto;
    }
    .header-barcode {
        height: auto;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;
